import { createContext } from 'react';

const initialAppContext: AppContextStore = {
  isSideNavOpen: false,
  isTouchDevice: false,
  unreadNotificationsCount: 0,
  allowedRoutes: [],
  isBrandAdmin: false,
  setIsSideNavOpen: () => {},
  setIsTouchDevice: () => {},
  setUnreadNotificationsCount: () => {},
  setAllowedRoutes: () => {},
  setIsBrandAdmin: () => {},
};

export const AppContext = createContext<AppContextStore>(initialAppContext);
